module.exports = __webpack_public_path__ + "static/media/completed-tasks.7f1f92cd.svg";